import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { useAuth } from '@/contexts/AuthContext';
import { ImpersonationBanner } from '@/components/ImpersonationBanner';
import { Spinner } from '@/components/ui/Spinner';
import { ToastProvider } from '@/components/ui/toast';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100dvh', background: 'var(--color-bg)',
      }}>
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <ToastProvider>
      <ImpersonationBanner />
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </ToastProvider>
  );
}
